import { createIcon } from '@chakra-ui/icons';

export const CameraAdd = createIcon({
  displayName: 'CameraAdd',
  viewBox: '0 0 25 21',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="21" viewBox="0 0 25 21" fill="none">
      <path
        d="M17.5 5.75002H15.1475L13.625 2.69127C13.5207 2.48252 13.36 2.30714 13.1612 2.18498C12.9624 2.06282 12.7334 1.99874 12.5 2.00002H7.5C7.26771 1.99991 7.03999 2.06453 6.84237 2.18663C6.64476 2.30873 6.48508 2.48348 6.38125 2.69127L4.8525 5.75002H2.5C1.83696 5.75002 1.20107 6.01341 0.732233 6.48225C0.263392 6.95109 0 7.58698 0 8.25002L0 18.25C0 18.9131 0.263392 19.5489 0.732233 20.0178C1.20107 20.4866 1.83696 20.75 2.5 20.75H17.5C18.163 20.75 18.7989 20.4866 19.2678 20.0178C19.7366 19.5489 20 18.9131 20 18.25V8.25002C20 7.58698 19.7366 6.95109 19.2678 6.48225C18.7989 6.01341 18.163 5.75002 17.5 5.75002ZM10 17C9.25832 17 8.5333 16.7801 7.91661 16.368C7.29993 15.956 6.81928 15.3703 6.53545 14.6851C6.25162 13.9999 6.17736 13.2459 6.32206 12.5184C6.46675 11.791 6.8239 11.1228 7.34835 10.5984C7.8728 10.0739 8.54098 9.71677 9.26841 9.57207C9.99584 9.42738 10.7498 9.50164 11.4351 9.78547C12.1203 10.0693 12.706 10.5499 13.118 11.1666C13.5301 11.7833 13.75 12.5083 13.75 13.25C13.75 14.2446 13.3549 15.1984 12.6517 15.9017C11.9484 16.6049 10.9946 17 10 17Z"
        fill="currentColor"
      />
      <circle cx="18.3047" cy="6" r="6" fill="white" />
      <g clipPath="url(#clip0_3010_11313)">
        <path
          d="M18.306 1.41675C15.7789 1.41675 13.7227 3.473 13.7227 6.00008C13.7227 8.52717 15.7789 10.5834 18.306 10.5834C20.8331 10.5834 22.8893 8.52717 22.8893 6.00008C22.8893 3.473 20.8331 1.41675 18.306 1.41675ZM20.3893 6.41675H18.7227V8.08342H17.8893V6.41675H16.2227V5.58341H17.8893V3.91675H18.7227V5.58341H20.3893V6.41675Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_3010_11313">
          <rect width="10" height="10" fill="white" transform="translate(13.3047 1)" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
